import { useState, useContext } from 'react';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import Loading from '../../components/loading';
import PlanInactiveBanner from '../../components/plan-inactive-banner/PlanInactiveBanner';
import DashboardPlanGate from '../../components/dashboard-plan-gate/DashboardPlanGate';

import { EntityContext } from '../../entity';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  const { loading, erro, setErro, errorMessage, entity, entityHasActivePlan } =
    useContext(EntityContext);

  const showPlanBanner =
    entity && typeof entity === 'object' && entity.api_key && entityHasActivePlan === false;

  return (
      <StyledRoot>
        <Header onOpenNav={() => setOpen(true)} erro={erro} setErro={setErro} errorMessage={errorMessage} />

        <Nav openNav={open} onCloseNav={() => setOpen(false)} />

        <Main>
        {showPlanBanner ? <PlanInactiveBanner /> : null}
        {loading && <Loading />}
          <DashboardPlanGate />
        </Main>
      </StyledRoot>
  );
}
